document.writeln('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/nyroModal-2.0.0/styles/nyroModal.min.css" media="screen" />');
document.write('<!--[if lt IE 7]><script type="text/javascript" src="/libs/vendor/jquery/nyroModal-2.0.0/js/jquery.nyroModal-ie6.min.js"></script><![endif]-->');
document.writeln('<style type="text/css">');
document.writeln('.nyroModalCloseButton { top: -23px; right: -23px; width: 30px; height: 30px; background: url(/libs/vendor/jquery/nyroModal-2.0.0/img/close.png) no-repeat; }');
//document.writeln('.nyroModalPrev:hover { background-image: url(/libs/vendor/jquery/nyroModal-2.0.0/img/prev-'+Config.languageISOCode+'.gif); }');
//document.writeln('.nyroModalNext:hover { background-image: url(/libs/vendor/jquery/nyroModal-2.0.0/img/next-'+Config.languageISOCode+'.gif); }');
document.writeln('</style>');
document.writeln('<link rel="stylesheet" type="text/css" href="/libs/vendor/video.js-5.8.1/video-js.min.css" media="screen" />');

_onload_functions[_onload_functions.length] = function() {
  jQuery.nmObj({
    'imageRegex': '[^\.]\.(jpg|jpeg|png|tiff|gif|bmp)(\\?.*)?\s*$',
    'modal': false,
    'closeButton': '<a href="/" class="nyroModalClose nyroModalCloseButton nmReposition" title="'+I18n.t('Close')+'">'+I18n.t('Close')+'</a>',
    'sizes': {'minW': 100, 'minH': 100},
    'callbacks': {
      'beforeShowCont': function(nm) {
        jQuery('.nyroModalPrev').attr({'href': Config.exec+'/', 'title': I18n.t('Previous')});
        jQuery('.nyroModalNext').attr({'href': Config.exec+'/', 'title': I18n.t('Next')});
      }
    }
  });

  jQuery("body").on("click", "a.lightbox", function() {
    jQuery(this).nyroModal().nmCall();
    return false;
  });
};